import { NameValueModel } from "@services/common/model/gloabal.model";
import { ReactComponent as LiganIcon } from "@assets/icons/ligand_icon.svg";
import { ReactComponent as RnaIcon } from "@assets/icons/rna_icon.svg";
import { ReactComponent as DnaIcon } from "@assets/icons/dna_icon.svg";
import { ReactComponent as ProteinIcon } from "@assets/icons/protein_icon.svg";
import { ReactComponent as CloudIcon } from "@assets/icons/cloud.svg";
import { ReactComponent as UploadIcon } from "@assets/icons/upload.svg";
import { ReactComponent as SeqIcon } from "@assets/icons/seq_icon.svg";
import {
  JobTypeEnum,
  BinderDesignTypeEnum,
  VhhDesignTypeEnum,
  AntibodyDesignBinderTypeEnum,
  PeptideDesignBinderTypeEnum,
} from "../enum/home.enum";
import { DataTypeModel } from "../model/home.model";

export const JOB_TYPE_LABEL_MAP = {
  [JobTypeEnum.ProteinBinderDesign]: "Protein Binder Design",
  [JobTypeEnum.VhhDesign]: "De Novo Antibody Design",
  [JobTypeEnum.AbAgDocking]: "Antibody-Antigen Docking",
  [JobTypeEnum.PeptideDesignLite]: "De Novo Peptide Design",
};

export const JOB_TYPE_LIST: NameValueModel[] = [
  {
    name: JOB_TYPE_LABEL_MAP[JobTypeEnum.VhhDesign],
    value: JobTypeEnum.VhhDesign,
  },
  {
    name: JOB_TYPE_LABEL_MAP[JobTypeEnum.PeptideDesignLite],
    value: JobTypeEnum.PeptideDesignLite,
  },
  {
    name: JOB_TYPE_LABEL_MAP[JobTypeEnum.AbAgDocking],
    value: JobTypeEnum.AbAgDocking,
  },
  {
    name: `${JOB_TYPE_LABEL_MAP[JobTypeEnum.ProteinBinderDesign]} (legacy)`,
    value: JobTypeEnum.ProteinBinderDesign,
  },
];

export const BINDER_DESIGN_TYPE_LABEL_MAP = {
  [BinderDesignTypeEnum.Ligand]: "Ligand (SMILES)",
  [BinderDesignTypeEnum.LigandCCD]: "Ligand (CCD)",
  [BinderDesignTypeEnum.RnaSequence]: "RNA(ss)",
  [BinderDesignTypeEnum.DnaSequence]: "DNA(ss)",
  [BinderDesignTypeEnum.RnaSequenceDs]: "RNA(ds)",
  [BinderDesignTypeEnum.DnaSequenceDs]: "DNA(ds)",
  [BinderDesignTypeEnum.ProteinChain]: "Protein",
};

export const PROTEIN_BINDER_DESIGN_TYPES: DataTypeModel[] = [
  {
    name: BINDER_DESIGN_TYPE_LABEL_MAP[BinderDesignTypeEnum.Ligand],
    value: BinderDesignTypeEnum.Ligand,
    icon: LiganIcon,
  },
  {
    name: BINDER_DESIGN_TYPE_LABEL_MAP[BinderDesignTypeEnum.LigandCCD],
    value: BinderDesignTypeEnum.LigandCCD,
    icon: LiganIcon,
  },
  {
    name: BINDER_DESIGN_TYPE_LABEL_MAP[BinderDesignTypeEnum.RnaSequence],
    value: BinderDesignTypeEnum.RnaSequence,
    icon: RnaIcon,
  },
  // {
  //   name: BINDER_DESIGN_TYPE_LABEL_MAP[BinderDesignTypeEnum.RnaSequenceDs],
  //   value: BinderDesignTypeEnum.RnaSequenceDs,
  //   icon: RnaIcon,
  // },
  // {
  //   name: BINDER_DESIGN_TYPE_LABEL_MAP[BinderDesignTypeEnum.DnaSequence],
  //   value: BinderDesignTypeEnum.DnaSequence,
  //   icon: DnaIcon,
  // },
  {
    name: BINDER_DESIGN_TYPE_LABEL_MAP[BinderDesignTypeEnum.DnaSequenceDs],
    value: BinderDesignTypeEnum.DnaSequenceDs,
    icon: DnaIcon,
  },
  {
    name: BINDER_DESIGN_TYPE_LABEL_MAP[BinderDesignTypeEnum.ProteinChain],
    value: BinderDesignTypeEnum.ProteinChain,
    icon: ProteinIcon,
  },
];

export const ADVANCED_PROTEIN_BINDER_DESIGN_TYPES: DataTypeModel[] = [
  {
    name: BINDER_DESIGN_TYPE_LABEL_MAP[BinderDesignTypeEnum.Ligand],
    value: BinderDesignTypeEnum.Ligand,
    icon: LiganIcon,
  },
  {
    name: BINDER_DESIGN_TYPE_LABEL_MAP[BinderDesignTypeEnum.LigandCCD],
    value: BinderDesignTypeEnum.LigandCCD,
    icon: LiganIcon,
  },
  {
    name: "RNA",
    value: BinderDesignTypeEnum.RnaSequence,
    icon: RnaIcon,
  },
  {
    name: "DNA",
    value: BinderDesignTypeEnum.DnaSequence,
    icon: DnaIcon,
  },

  {
    name: BINDER_DESIGN_TYPE_LABEL_MAP[BinderDesignTypeEnum.ProteinChain],
    value: BinderDesignTypeEnum.ProteinChain,
    icon: ProteinIcon,
  },
];

export const VHH_DESIGN_TYPE_LABEL_MAP = {
  [VhhDesignTypeEnum.PdbID]: "PDB ID",
  [VhhDesignTypeEnum.UniProtID]: "UniProt ID",
  [VhhDesignTypeEnum.AntigenSequence]: "Antigen sequence",
  [VhhDesignTypeEnum.UploadStructure]: "Upload structure",
};

export const VHH_DESIGN_TYPES: DataTypeModel[] = [
  {
    name: VHH_DESIGN_TYPE_LABEL_MAP[VhhDesignTypeEnum.PdbID],
    value: VhhDesignTypeEnum.PdbID,
    icon: CloudIcon,
  },
  {
    name: VHH_DESIGN_TYPE_LABEL_MAP[VhhDesignTypeEnum.UniProtID],
    value: VhhDesignTypeEnum.UniProtID,
    icon: CloudIcon,
  },
  // {
  //   name: VHH_DESIGN_TYPE_LABEL_MAP[VhhDesignTypeEnum.AntigenSequence],
  //   value: VhhDesignTypeEnum.AntigenSequence,
  //   icon: SeqIcon,
  // },
  {
    name: VHH_DESIGN_TYPE_LABEL_MAP[VhhDesignTypeEnum.UploadStructure],
    value: VhhDesignTypeEnum.UploadStructure,
    icon: UploadIcon,
  },
];

export const AlphaBet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const ANTIBODY_DESIGN_TYPE_MAP = {
  [AntibodyDesignBinderTypeEnum.Vhh]: "VHH",
  [AntibodyDesignBinderTypeEnum.Scfv]: "IgG",
};

export const PEPTIDE_DESIGN_TYPE_MAP = {
  [PeptideDesignBinderTypeEnum.LinPep]: "Linear",
  [PeptideDesignBinderTypeEnum.DisulPep]: "Disulphide-cyclized",
  [PeptideDesignBinderTypeEnum.CycPep]: "Backbone-cyclized",
};
